import { useAtomValue } from "jotai";
import type { Answer } from "../../../components/Questionnaire/Section/Question/types";
import { questionnaireAnswerAtom } from "../state/questionnaireAnswerAtom";

/**
 * Get a single answer. Only re-renders when this answer changes.
 *
 * @example const businessType = useAnswer('business_type');
 * @see useAnswers - all answers (re-renders on any change)
 */
export function useAnswer(questionName: string): Answer | undefined {
  return useAtomValue(questionnaireAnswerAtom(questionName));
}
